// extracted by mini-css-extract-plugin
module.exports = {"setting-modal":"SchedulingPeriodSetting_setting-modal__1PZCe","setting-modal-empty":"SchedulingPeriodSetting_setting-modal-empty__1S2PE"};